import gql from 'graphql-tag';

const CATEGORY = gql`
  query Query {
    device360Categories {
      category
    }
  }
`;

export default CATEGORY;
